// removed by extract-text-webpack-plugin
module.exports = {"container":"_3J88TpVHcanwiotDu8oJsH","routes":"gjdzoPlGZGSNtUWGAbFJ"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Preparation/SSSellNote/styles.css
// module id = 3275
// module chunks = 0